// extracted by mini-css-extract-plugin
export default {"row":"AllProductsItem_row__40aCI","col":"AllProductsItem_col__8b1zy"};